

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import DetailDialog from "./DetailDialog.js";
import SubscribeBtn from "./SubscribeBtn.js";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);

    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');

    const handleOpen = (value) => {
        console.log(value)
        if (!value.isRead) {
            notificationRead(value.id)
        }
        setSelectedValue(value)
        setOpen(true);
    };

    const handleClose = (value, type) => {
        setOpen(false);
    };

    async function notificationRead(id) {
        try {
            let res = await UserApi.notificationRead({ id: id })
            console.log(res.data.data)

            const updatedDataList = dataList.map(item => {
                if (item.id === id) {
                    // 如果id匹配selid，将name更改为'aiden'
                    return { ...item, isRead: true };
                }
                return item;
            });
            setDataList(updatedDataList);
            updateMe()

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
    }


    const { setLoading, successToast, errorToast, updateMe } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const handleChange = (event, value) => {
        setPage(value);
        getDataList(value)
    };

    const [dataList, setDataList] = useState(null)

    async function getDataList(page) {
        setLoading(true)
        try {
            let res = await UserApi.notificationSearch({ page: page })
            console.log(res.data.data)
            setDataList(res.data.data)
            setTotalPage(res.data.total == 0 ? 1 : Math.ceil(res.data.total / 10))

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        getDataList(1)
    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="flex gap-4 items-center mb-4">
            <div className="text-lg font-bold ">{t('memberCenterType.message')}</div>
            <SubscribeBtn />
        </div>
        <div className="   whitespace-nowrap w-full  overflow-x-auto pb-10">
            <table className="w-full text-sm" >
                <thead className="">

                    <tr className="bg-black02  text-black96 font-semibold text-xs">
                        <th className="">日期</th>
                        <th className="">訊息內容</th>
                        <th className="">狀態</th>
                        <th className=""></th>
                    </tr>
                </thead>

                <tbody>
                    {
                        dataList && dataList.map(i => <tr key={i.id} className="align-top text-black9 font-semibold ">
                            <td className="">{i.createdAt}</td>
                            <td className="">{i.content}</td>
                            <td>{i.isRead ? <p className="text-red1">已讀</p> : <p className="text-black6">未讀</p>}</td>
                            <td>
                                <button onClick={() => handleOpen(i)} className="text-red1 font-bold rounded-md bg-white px-2 py-1 border-solid border border-red1">
                                    詳細
                                </button>
                            </td>

                        </tr>
                        )
                    }

                </tbody>
            </table>



        </div>
        {
            dataList != null ?
                <>
                    {
                        dataList.length == 0 ?
                            <div className="  text-center text-gray-400 text-lg w-full font-bold  mb-16 ">
                                <div>暫無紀錄</div>
                            </div> : ""

                    }

                    <div className="flex w-full  mt-4 mb-2">
                        <div className="mx-auto">
                            <Pagination count={totalPage} page={page} onChange={handleChange} />
                        </div>
                    </div>
                </>
                : ""
        }
        <DetailDialog
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose} />

    </div>

}

export default Home